import Aqumen from "@aqumen/sdk";
import React, {useState} from "react";
import {useIntl} from "react-intl";
import {useSelector} from "react-redux";
import {useDebouncedCallback} from "use-debounce";

import {blurOnEnter} from "@/library/utility/blur_on_enter.js";
import {editableRole} from "./editable_role.js";

export function RoleDescriptionTile(props) {
  const intl = useIntl();

  const session = useSelector(s => s.accessControlSession);
  const [description, setDescription] = useState(props.role.description ?? "");

  const submit = (description) => Aqumen.Role.update(
    session, {id: props.role.id}, {description}
  );
  const debouncedSubmit = useDebouncedCallback(submit, 1000);

  const handleChange = async (event) => {
    setDescription(event.target.value);
    await debouncedSubmit(event.target.value);
  };

  const handleBlur = (event) => {
    debouncedSubmit.cancel();
    if (event.target.value !== props.role.description) {
      return submit(event.target.value);
    }
  };

  const disabled = props.role.level !== "user" || props.role.archivedAt;
  return (
    <div className="role-description-tile">
      <label className="role-description label">
        <span className="role-description label-text">
          {intl.formatMessage({id: "roles.role.description.label"})}
        </span>
        <input className="role-description"
               type="text"
               disabled={!editableRole(props.role)}
               value={description}
               onBlur={handleBlur}
               onChange={handleChange}
               onKeyUp={blurOnEnter}/>
      </label>
    </div>
  );
}
